import React, { useState, useEffect } from 'react';
import './WeddingCountdownTimer.css'; // Import the CSS file

const FlipCard = ({ value, unit }) => {
  const [flip, setFlip] = useState(false);

  useEffect(() => {
    setFlip(true);
    const timer = setTimeout(() => setFlip(false), 600);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div className="flip-card">
      <div className={`flip-card-inner ${flip ? 'flipped' : ''}`}>
        <div className="flip-card-front">
          <span className="flip-card-number">{value}</span>
        </div>
        <div className="flip-card-back">
          <span className="flip-card-number">{value}</span>
        </div>
      </div>
      <div className="flip-card-unit">{unit}</div>
    </div>
  );
};

const WeddingCountdownTimer = () => {
    const [timeLeft, setTimeLeft] = useState({
      months: 0,
      weeks: 0,
      days: 0,
    });
  
    useEffect(() => {
      const weddingDate = new Date('2025-05-31T00:00:00');
  
      const calculateTimeLeft = () => {
        const now = new Date();
        const difference = weddingDate.getTime() - now.getTime();
  
        if (difference > 0) {
          let months = (weddingDate.getFullYear() - now.getFullYear()) * 12;
          months -= now.getMonth();
          months += weddingDate.getMonth();
  
          if (now.getDate() > weddingDate.getDate()) {
            months--;
          }
  
          const monthDiffDate = new Date(now);
          monthDiffDate.setMonth(now.getMonth() + months);
          const daysDifference = Math.floor((weddingDate - monthDiffDate) / (1000 * 60 * 60 * 24));
  
          const weeks = Math.floor(daysDifference / 7);
          const remainingDays = daysDifference % 7;
  
          setTimeLeft({
            months,
            weeks,
            days: remainingDays,
          });
        }
      };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000 * 60 * 60); // Update every hour

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown-container">
      <div className="countdown-inner">
        <h2 className="countdown-title">Countdown to Our Special Day</h2>
        <div className="countdown-cards">
          {Object.entries(timeLeft).map(([unit, value]) => (
            <FlipCard key={unit} value={value} unit={unit.charAt(0).toUpperCase() + unit.slice(1)} />
          ))}
        </div>
        <div className="add-to-calendar">
          <a href="../wedding-invite.ics" className="btn calendar-button" role="button">Add to Calendar</a>
        </div>
      </div>
    </div>
  );
};

export default WeddingCountdownTimer;